module.exports = __webpack_public_path__ + "img/RoR_Logo.e217b6dd.png";